import { useViewData } from "../view-data";

import type * as Repository from "../../../../_repository";

type Props = {
	// 検索日
	searchDate: string;
	// オプションリスト
	optionPmsActiveListQueryData: Repository.Query.QueryData.OptionPmsList.OptionPmsActiveListQueryData;
	optionPmsColorListQueryData: Repository.Query.QueryData.OptionPmsColorListQueryData;
};

export const useInitialized = ({ searchDate, optionPmsActiveListQueryData, optionPmsColorListQueryData }: Props) => {
	/**
	 * ViewData の生成
	 */
	const { viewData } = useViewData({
		searchDate,
		optionPmsColorListQueryData,
		optionPmsActiveListQueryData,
	});

	return {
		//
		viewData,
	};
};
